var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 64,
    height: 64,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 47.5a3 3 0 003-3v-22a3 3 0 00-3-3h-3v-3.25a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v3.25h-8v-3.25a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v3.25h-3a3 3 0 00-3 3v22a3 3 0 003 3h22zm-.375-3h-21.25a.376.376 0 01-.375-.375V25.5h22v18.625a.376.376 0 01-.375.375zm-15.375-11c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5zm6 0c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5zm6 0c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5zm-6 6c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5zm-6 0c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5zm12 0c.413 0 .75-.337.75-.75v-2.5a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75v2.5c0 .413.337.75.75.75h2.5z",
    fill: "#1F1F1F"
  })));
};

export default SvgCalendar;